import { render, staticRenderFns } from "./ExportDataModal.vue?vue&type=template&id=2f90c76e&"
import script from "./ExportDataModal.vue?vue&type=script&lang=js&"
export * from "./ExportDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports